import { UpdatableItemManager, IUpdatableItem } from "../../Utils/UpdatableItemManager";
import { ScorePopup } from "../ScorePopup";
import { Game, eFontAsset, eAtlas_0 } from "../../Game";
import { DeliveryBonus } from "./DeliveryBonus";
import { Player } from "../Player/Player";
import { BonusBar } from "./BonusBar";
import { eBonusUID } from "../Bonuses/Bonus";
import { BonusManager } from "../Bonuses/BonusManager";
import { ActiveBonus } from "../Bonuses/ActiveBonus";
import { NodeList } from "../../Utils/Collections/NodeList";
import { Node } from "../../Utils/Collections/Node";
import { Gameplay } from "../Gameplay";
import { LevelIntro } from "./LevelIntro";
import { KeepPlaying } from "./KeepPlaying";



export class HUD {
    private static readonly _BONUS_BAR_Y = -70;
    private static readonly _BONUS_BAR_X = 20;
    private static readonly _BONUS_BAR_SLOT_W = 60;

    /**
     * (RO) Staticky pristup
     */
    static get instance(): HUD { return HUD._instance; }
    private static _instance: HUD;

    private _screen: pc.Entity;

    /**
     * (RO) Element zobrazujici aktualni skore
     */
    /*get score(): pc.ElementComponent { return this._score.element; }
    private _score: pc.Entity;*/

    /**
     * Spravce vyskakujicich zprav se skore
     */
    private _scorePopups: UpdatableItemManager;

    /**
     * Zobrazeni zbyvajiciho bonusu za rychle doruceni balicku
     */
    private _deliveryBonus: DeliveryBonus;

    /**
     * Zobrazeni prubehu platnosti bonusu
     */
    private _bonusBars: BonusBar[];

    /**
     * Seznam aktivnich baru pro bonusy
     */
    private _actBonusBars: NodeList<BonusBar>;

    /**
     * Zobrazeni poctu dorucenych balicku
     */
    private _deliveredPkgCnt: pc.Entity;

    /**
     * (RO) Predstaveni noveho levelu
     */
    get lvlIntro(): LevelIntro { return this._lvlIntro; }
    private _lvlIntro: LevelIntro;

    /**
     * (RO) Obrazovka s dotazem na EXTRA ZIVOT
     */
    get keepPlaying(): KeepPlaying { return this._keepPlaying; }
    private _keepPlaying: KeepPlaying;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        HUD._instance = this;

        this._scorePopups = new UpdatableItemManager(1, true, (): IUpdatableItem => {
            return new ScorePopup();
        }, this);

        // 2D screen
        this._screen = new pc.Entity("hud");
        this._screen.addComponent(pc.eCompomentType.screen, {
            scaleMode: pc.SCALEMODE_NONE,
            screenSpace: true,
        });

        Game.APP.root.addChild(this._screen);

        // Pocet dorucenych balicku
        this._deliveredPkgCnt = new pc.Entity();
        this._deliveredPkgCnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [1, 1, 1, 1],
            pivot: [1, 1],
            fontSize: 36,
            fontAsset: Game.APP.assets.find(eFontAsset.default, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
        });
        this._deliveredPkgCnt.element.shadowColor.set(0, 0, 0, 1);
        this._deliveredPkgCnt.element.shadowOffset.set(1, -1);
        this._deliveredPkgCnt.setLocalPosition(-20, -20, 0);
        this._screen.addChild(this._deliveredPkgCnt);

        Gameplay.instance.events.on(Player.EVENT_PARCEL_DELIVERED, this.handlePkgDelivered, this);

        // Bonus za doruceni
        this._deliveryBonus = new DeliveryBonus(this._screen, Player.instance.deliveryBonus);

        // Bonusy
        this._actBonusBars = new NodeList<BonusBar>();

        this._bonusBars = [
            new BonusBar(this._screen, HUD._BONUS_BAR_Y, eBonusUID.shield, eAtlas_0.shieldBar, eAtlas_0.shieldBarFill),
            new BonusBar(this._screen, HUD._BONUS_BAR_Y, eBonusUID.scoreMultiplier, eAtlas_0.scoreMultiBar, eAtlas_0.scoreMultiBarFill)
        ];

        // Sledovat aktivaci a deaktivaci bonusu
        this._bonusBars.forEach((bar: BonusBar) => {
            BonusManager.instance.events.on(BonusManager.EVENT_BONUS_ACTIVATE + bar.bonusUID, this.handleBonusAct, this);
            BonusManager.instance.events.on(BonusManager.EVENT_BONUS_DEACTIVATE + bar.bonusUID, this.handleBonusDeact, this);
        });

        // Predstaveni levelu
        this._lvlIntro = new LevelIntro(this._screen);

        // Extra zivot
        this._keepPlaying = new KeepPlaying(this._screen);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(newLevel: boolean): void {
        if (newLevel) {
            // Reset po prechodu do noveho levelu
            this._scorePopups.reset();
            this._deliveryBonus.reset();
            this._bonusBars.forEach((bar: BonusBar) => { bar.reset(); });
            this._actBonusBars.clear();
            this.handlePkgDelivered(0, 0);
        }
        else {
            // Zakladni reset
            this._lvlIntro.reset();
            this._keepPlaying.reset();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showScorePopup(x: number, y: number, z: number, text: string): void {
        (<ScorePopup>this._scorePopups.activateItem()).show(x, y, z, text);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._scorePopups.update();
        this._deliveryBonus.update();
        this._bonusBars.forEach((bar: BonusBar) => { bar.update(); });
        this._lvlIntro.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handlePkgDelivered(pkgCnt: number, totPkgCnt: number): void {
        this._deliveredPkgCnt.element.text = totPkgCnt + "-" + Gameplay.instance.levelPackageCnt;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusAct(bonus: ActiveBonus, react: boolean): void {
        if (!react) {
            // Najit bar pro bonus a nastavit jeho pozici na ose X
            let i = this._bonusBars.length;

            while (i-- != 0) {
                if (this._bonusBars[i].bonusUID == bonus.bonus.uid) {
                    this._bonusBars[i].setX(HUD._BONUS_BAR_X + HUD._BONUS_BAR_SLOT_W * this._actBonusBars.size);
                    this._actBonusBars.add(this._bonusBars[i]);
                    break;
                }
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusDeact(bonusUID: eBonusUID): void {
        // Odstranit bar s deaktivovanym bonusem ze seznam aktivnich baru a posunout dalsi bary vlevo
        let shift = false;

        this._actBonusBars.forEach((bar: BonusBar, node: Node<BonusBar>, i: number) => {
            if (!shift) {
                if (bar.bonusUID == bonusUID) {
                    this._actBonusBars.removeByNode(node);
                    shift = true;
                }
            }
            else {
                bar.setX(HUD._BONUS_BAR_X + HUD._BONUS_BAR_SLOT_W * i);
            }
        })
    }
}